import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(1, 'Password is required'),
});

export const registerSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  full_name: z.string().min(1, 'Full name is required'),
  role: z.enum(['admin', 'super_admin']).optional(),
});

export const eventSchema = z.object({
  name: z.string().min(1, 'Event name is required'),
  description: z.string().optional(),
  start_date: z.string().optional().nullable(),
  end_date: z.string().optional().nullable(),
  location: z.string().optional(),
  is_active: z.boolean().optional(),
});

export const customFieldSchema = z.object({
  field_name: z.string().min(1, 'Field name is required'),
  field_label: z.string().min(1, 'Field label is required'),
  field_type: z.enum(['text', 'email', 'phone', 'number', 'select', 'radio', 'checkbox', 'textarea', 'date', 'file']),
  field_options: z.array(z.string()).optional(),
  is_required: z.boolean().optional(),
  validation_rules: z.object({}).optional(),
  display_order: z.number().optional(),
  show_on_badge: z.boolean().optional(),
});

export const validateField = (value, field) => {
  if (field.is_required && (!value || value.trim() === '')) {
    return `${field.field_label} is required`;
  }

  if (field.field_type === 'email' && value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return 'Invalid email address';
    }
  }

  if (field.field_type === 'phone' && value) {
    const phoneRegex = /^[\d\s\-()]+$/;
    if (!phoneRegex.test(value)) {
      return 'Invalid phone number';
    }
  }

  return null;
};
